import type { Handler } from './handler';
import type {
  ApiFetchGiratudoHistoryPort,
  RaffleHistoryResponse,
} from './ports/api-fetch-giratudo-history.port';
import { tryCatch } from '~/utils/apostatudo/try-catch';
import { resolveAdapter } from '~/adapters/registry';

export const fetchGiratudoHistoryHandler: Handler<
  Params,
  Ports,
  Result
> = async (
  params,
  ports = {
    apiFetchGiratudoHistory: resolveAdapter('apiFetchGiratudoHistory'),
  },
) => {
  const [history, error] = await tryCatch(
    ports.apiFetchGiratudoHistory.handle(
      params.userId,
      params.page,
      params.perPage,
    ),
  );

  if (error) {
    console.error('Error fetching giratudo history:', error);

    return {
      data: [],
      currentPage: 1,
      totalPages: 0,
    };
  }

  return history as RaffleHistoryResponse;
};

type Params = { userId: number; page?: number; perPage?: number };

type Ports = { apiFetchGiratudoHistory: ApiFetchGiratudoHistoryPort };

type Result = Promise<RaffleHistoryResponse>;
